import { useState } from "react";
import { AP_Master } from "../../Configuration/API_URL";
import { ApiResDecrypt } from "../../CommonMethhods/CommonMethods";
import axiosInstance from "../../CommonMethhods/axiosInstance";

const deactivateAp = async (payload) => {
  const token = localStorage.getItem("ssoToken");
  const response = await axiosInstance.post(AP_Master.DEACTIVATE_AP, payload);
  return response.data;
};

export const useDeactivate = () => {
  const [isLoading, setIsLoading] = useState(false);

  const deactivateAP = async (payload) => {
    setIsLoading(true);

    try {
      const response = await deactivateAp(payload);
      const decryptedResponse = ApiResDecrypt(response);
      if (decryptedResponse.status === 0) {
        return { success: true, data: decryptedResponse };
      }
      return { success: false, data: decryptedResponse };
    } catch (err) {
      console.error(err);
      return { success: false };
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, deactivateAP };
};
